
class MainProduct extends HTMLElement {
  values; loader; variantPicker;

  connectedCallback(){
    this.init();
  }

  init = () => {
    this.values = this.querySelectorAll('variant-picker-value');
    this.loader = this.querySelectorAll('.form-loader');
    this.variantPicker = this.querySelector('variant-picker');
    this.values.forEach(value => {
      value.addEventListener('click', () => {
        this.refreshVariant(value);
      });
    });
    this.closeLoader();
  }

  refreshApps = () => {
    const variant = this.variantPicker.getVariant();
    if(window.WishListHero_SDK != undefined){
      var x = {
        ButtonClassElement: 'product-form__item',
        ProductId: this.dataset.id,
        ProductLink: location.href,
        ProductVariantId: variant.id,
        ProductPrice: variant.price,
        ProductTitle: this.dataset.title,
        ProductImage: variant.featured_image ? variant.featured_image.src : document.querySelector('#main-product-slider > div > div > a > picture > img').src,
        ButtonMode: "text_with_icon",
        WishlistHash: window.WishListHero_SDK.GetWishListHash(true)
      };
      WishListHero_SDK.InitializeAddToWishListButton(x);
    }
    dispatchBIS(window.location.search.substring(1));
  }

  refreshVariant = (value) => {
    this.openLoader();
    const url = value.getUrl();
    $.ajax({
      type: 'get',
      url: url,
      cache: false,
      contentType: false,
      processData: false,
      success: (response) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(response, 'text/html');
        this.innerHTML = doc.querySelector('main-product').innerHTML;
        this.setUrl(url);
        this.refreshApps();
        this.init();
        initPage();
        this.closeLoader();
      },
      error: (err) => {
        console.log(err);
        this.closeLoader();
        Swal.fire({
          "icon": "error",
          "title": "There was an error", 
          "text": "Please retry"
        });
      }
    });
  }

  openLoader = () => {
    this.loader.forEach(element => {
      element.classList.remove('d-none');
    });
  }

  closeLoader = () => {
    this.loader.forEach(element => {
      element.classList.add('d-none');
    });
  }

  setUrl = (url) => {
    window.history.replaceState({}, '', url);
  }
  
}
if (!window.customElements.get("main-product")) {
  window.customElements.define("main-product", MainProduct);
}